import { render, staticRenderFns } from "./LandscapeSimulator.vue?vue&type=template&id=185dccf6&"
import script from "./LandscapeSimulator.vue?vue&type=script&lang=js&"
export * from "./LandscapeSimulator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports